module.exports = __webpack_public_path__ + "static/media/redesign-web-bac-mono.3f72acd2.png";